import { useEffect, useState } from "react";
import "../showCart/sowCart.css";
import { Link } from "react-router-dom";
import { axiosTokenInstance } from "../../axiosConfig/axios";

import { SaudiRiyal } from "lucide-react";

const ShowCart = () => {
  let [totalPrice, setTotalPrice] = useState(null);
  let [cartProductsLength, setCartProductsLength] = useState(null);
  // get cart product details
  const getCartDetails = () => {
    axiosTokenInstance.get("/connector/api/users/cart").then((res) => {
      // console.log(res.data.data);

      if (res.data.data) {
        setTotalPrice(res.data.data.cart_calculates.final_price);

        setCartProductsLength(res.data.data.products.length);
      }
    });
  };

  useEffect(() => {
    getCartDetails();
  }, []);

  return (
    <>
      {totalPrice && cartProductsLength && (
        <div className="main-content-cart">
          <div className="showCart">
            <Link to="/cart" className="link">
              <div className="main-content">
                <div className="content">
                  <p>
                    <span>{cartProductsLength ? cartProductsLength : 0}</span>{" "}
                    عرض السلة
                  </p>
                </div>
                <p className="price" style={{ margin: "0" }}>
                  {cartProductsLength ? totalPrice : 0}
                  <span>
                    <SaudiRiyal size={18} />
                  </span>
                </p>
              </div>
            </Link>
          </div>
        </div>
      )}{" "}
    </>
  );
};

export default ShowCart;
